import React, { useRef } from "react";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_BasicLink } from "@danishagro/shared/src/components/atoms/BasicLink/BasicLink.component";
import { DA_Container } from "@danishagro/shared/src/components/atoms/Container/Container.component";
import { DA_NavigationPage } from "@danishagro/shared/src/interfaces/navigationPage.interface";
import { useLocation } from "react-router-dom";
import { useSiteHeader } from "@danishagro/shared/src/contexts/siteHeader.context";
import { adjustUrl } from "@danishagro/shared/src/helpers/adjustUrl.helper";
import { useAppData } from "@danishagro/shared/src/contexts/appData.context";
import { MenuProps } from "../Menu/Menu.props";
import S from "./MenuB2c.module.scss";

export const Menub2c = (props: MenuProps) => {
    const { toggleMobileNav } = useSiteHeader();
    const { pathname } = useLocation();
    const { currentSite } = useAppData();

    const menuElementRef = useRef<HTMLDivElement>();
    return (
        <div className={S.wrapper}>
            <div className={S.menu} ref={menuElementRef}>
                {/** First Level only */}
                <div className={S.section}>
                    <DA_Container>
                        {/** Items */}
                        {props.menuItems
                            ?.filter((x: DA_NavigationPage) => !x.hideInNavigation)
                            .map((item, index) => {
                                const isActive =
                                    pathname === adjustUrl(item.url || item.path, currentSite);

                                return (
                                    <div className={S.item} key={index}>
                                        <DA_BasicLink
                                            target={item.url ? "_blank" : "_self"}
                                            href={adjustUrl(
                                                item.metaUrl || item.url || item.path,
                                                currentSite
                                            )}
                                            onClick={toggleMobileNav}
                                            className={cn(S.link, { [S.isActive]: isActive })}
                                        >
                                            {item.name}
                                        </DA_BasicLink>
                                    </div>
                                );
                            })}
                    </DA_Container>
                </div>

                <div className={S.bottomLinksWrapper}>
                    <ul className={S.bottomLinks}>
                        {/* Universal menu bottom links */}
                        {Array.isArray(globalThis?.universalMenuArr) &&
                            globalThis?.universalMenuArr?.map((menu, index) => {
                                return (
                                    <li key={index} className={S.linkItem}>
                                        <a
                                            href={menu.url}
                                            target={menu.target || "_self"}
                                            className={S.link}
                                        >
                                            <span>{menu.name}</span>
                                        </a>
                                    </li>
                                );
                            })}
                    </ul>
                </div>
            </div>
        </div>
    );
};
